// extracted by mini-css-extract-plugin
module.exports = {"container":"Error_container__2deOn","Card":"Error_Card__nvXNp","cardWrapper":"Error_cardWrapper__2GPyO","imgWrapper":"Error_imgWrapper__33o5D","btn":"Error_btn__3RAph"};